import React from "react";
import { Outlet } from "react-router-dom";
import AgeGateCover from "../Components/Organisms/AgeGateCover";
function PageWrap() {
  return (
    <div>
      <AgeGateCover />
      <Outlet />
    </div>
  );
}
export default PageWrap;
